import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import CustomerDetailPage from '@features/admin/customers/CustomerDetailPage.tsx';
import { useAdminCustomerDetailStore } from '@features/admin/customers/useAdminCustomerDetailStore.ts';

const paramsSchema = z.object({
  customerId: z.coerce.number().positive(),
});

const searchSchema = z.object({
  tab: z.enum(['auctions', 'products', 'prices']).optional().default('auctions'),
  page: z.coerce.number().optional().default(1),
  size: z.coerce.number().optional().default(20),
  q: z.string().optional(),
  supplierId: z.coerce.number().optional(),
  auctionId: z.coerce.number().optional(),
  priceType: z.enum(['STANDARD', 'ACTION_PRICE', 'SUBSTITUTE_PRICE', 'FROM_DL_PRICE']).optional(),
  // Pozor na z.coerce.boolean() - ten by ze stringu "false" udelal true, takze by se
  // rucne poslany odkaz s ?isGuaranteed=false choval jako filtr na garantovane.
  isGuaranteed: z
    .union([z.boolean(), z.literal('true'), z.literal('false')])
    .transform(v => v === true || v === 'true')
    .optional(),
});

export const Route = createFileRoute('/admin/customers/$customerId')({
  params: { parse: v => paramsSchema.parse(v) },
  validateSearch: search => searchSchema.parse(search),
  component: RouteComponent,
  beforeLoad: async ({ params, search }) => {
    const customerId = paramsSchema.parse(params).customerId;
    const store = useAdminCustomerDetailStore.getState();

    await store.loadCustomerDetail(customerId);

    const { tab, page, size, q, supplierId, auctionId, priceType, isGuaranteed } = search;
    await Promise.all([
      store.loadFilterLov(customerId),
      store.loadAuctions(customerId, tab === 'auctions' ? { page, size, q } : { page: 1, size: 20 }),
      store.loadProducts(customerId, tab === 'products' ? { page, size, q } : { page: 1, size: 20 }),
      store.loadPrices(
        customerId,
        tab === 'prices' ? { page, size, q, supplierId, auctionId, priceType, isGuaranteed } : { page: 1, size: 20 },
      ),
    ]);
  },
});

function RouteComponent() {
  const { customerId } = Route.useParams();
  return <CustomerDetailPage customerId={customerId} />;
}
